module.exports = str => {
  if (!str) return "";
  return str
    .trim()
    .toLowerCase()
    .replace(/[^\s\w-]+/g, "")
    .replace(/[^\w]+/g, "-");
};



// WEBPACK FOOTER //
// ./src/pages/templates/helpers/classify.js